<!-- 商品 -->
<template>
    <van-card
        :desc="cardData.sku"
        :title="cardData.name"
    >
        <template #thumb>
            <div class="img-box">
                <div class="tag" v-if="cardData.goodsKinds">{{ getGoodsType(cardData.goodsKinds) }}</div>
                <van-image :src="cardData.picUrl" />
            </div>
        </template>
        <template v-if="priceSolt" #price>
            <div class="goods-price-num-box">
                <div class="goods-price">¥{{cardData.salePrice}}</div>
                <div class="goods-pay-num">
                    <van-stepper v-model="skuNum" min="1" max="999" integer @change="handleSkuNum" />
                </div>
            </div>
        </template>
        <template v-else #price>
            <div class="goods-price-num-box">
                <div class="goods-price">¥{{cardData.salePrice}}</div>
                <div class="goods-pay-num">
                    x {{cardData.saleCount || 1}}
                </div>
            </div>
        </template>
        <template v-if="priceSolt" #num>
        </template>
    </van-card>
</template>
<script>
import {goodsTypeList} from '../config/enum'
export default {
    name: 'goodsCard',
    props: {
        priceSolt: {
            type: Boolean,
            default: false
        },
        cardData: {
            type: Object,
            default: ()=>{}
        },
        num: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            skuNum: 1,
        }
    },
    methods: {
        handleSkuNum() {
            this.$emit('onChangeNum', this.skuNum)
        },
        getGoodsType(value) {
            const result = goodsTypeList.filter(v=>v.value ===  value)
            return result.length? result[0].label : ''
        }
    },
};
</script>
<style lang="less" scoped>
.px2rem(@name,@px){
    @{name}: @px / 37.5px * 1rem
}
.img-box {
    position: relative;
    width: 240px;
    height: 180px;
    border-radius: 14px;
    border: 1px solid #d8d8d8;
    overflow: hidden;
    box-sizing: border-box;
    .van-image {
        height: 100%;
        width: 100%;
    }
    .tag {
        position: absolute;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 14px 0px 8px 0px;
        padding: 8px 12px;
        color: #fff;
        font-size: 20px;
        z-index: 1;
    }
}

.goods-price-num-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .goods-price {
        color: #999;
        font-weight: 500;
        font-size: 32px;
        font-family: AvenirNext-Medium, AvenirNext;
    }
    ::v-deep {
        .van-stepper__minus,.van-stepper__plus {
            .px2rem(height, 40);
            background-color: #fff;
            &::before {
                .px2rem(width, 20);
                .px2rem(height, 4);
            }

        }
        .van-stepper__plus::after{
            .px2rem(width, 4);
            .px2rem(height, 20);
        }
        .van-stepper__input {
            .px2rem(width, 72);
            .px2rem(height, 40);
            .px2rem(font-size, 28);
            color: #333;
        }
    }
}

.van-card {
    background-color: #fff;
    padding: 0;
    .px2rem(padding-top, 19);
    .px2rem(padding-bottom, 30);
    margin-top: 0;
    .van-card__thumb {
        .px2rem(width, 240);
        .px2rem(height, 180);
        img {
            border-radius: 0;
        }
    }
    .van-card__content {
        min-height: auto;
    }
    .van-card__title {
        color: #333;
        font-weight: 500;
        .px2rem(font-size, 30);
        .px2rem(max-height, 84);
        .px2rem(line-height, 42);
    }
    .van-card__desc {
        .px2rem(font-size, 20);
        .px2rem(max-height, 32);
        .px2rem(line-height, 32);
    }
    .van-card__price {
        .px2rem(font-size, 30);
        .px2rem(line-height, 32);
        color: #999;
        font-weight: normal;
        font-family: PingFangSC-Regular, PingFang SC;
    }
    .van-card__price-currency {
        .px2rem(margin-right, 4);
    }
    .van-card__price-integer, .van-card__price-decimal {
        .px2rem(font-size, 28);
        font-family: PingFangSC-Regular, PingFang SC;
    }
    .van-card__num {
        .px2rem(font-size, 28);
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999;
        .px2rem(line-height, 32);
    }
    .van-card__price {
        width: 100%;
    }
    .van-card__bottom {
        width: 100%;
        .goods-price-num-box {
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: space-between;
        }
        
        float: none;
    }
}
::v-deep {
    .van-card__thumb img {
        border-radius: 0
    }
}
 
</style>